import { createEntityAdapter } from "@reduxjs/toolkit";
import { WebOrderContent } from "./dataTypes";

export const webOrderContentAdapter = createEntityAdapter<WebOrderContent>({});
